<template>
  <div>
    <action-bar>
      <!--<button class="btn btn-danger" v-if="$route.params.userId">Benutzer löschen</button>
      <button class="btn btn-secondary" v-if="$route.params.userId">Neues Passwort zusenden</button>-->
    </action-bar>
    <main class="content">
      <h1>Benutzer bearbeiten</h1>
      <form @submit.prevent="save">
        <div class="form-group">
          <label for="username">Benutzername</label>
          <input type="text" class="form-control" id="username" v-model="user.username">
        </div>
        <div class="form-group">
          <label for="email">E-Mail Adresse</label>
          <input type="email" class="form-control" id="email" v-model="user.email">
        </div>

        <div class="form-group">
          <label for="password">Neues Passwort</label>
          <input type="password" class="form-control" id="password" v-model="password">
        </div>
        <div class="form-group">
          <label for="password-repeat">Neues Passwort bestätigen</label>
          <input type="password" class="form-control" id="password-repeat" v-model="passwordRepeat">
        </div>
        <!--
        <div class="form-group">
          <label for="role">Benutzergruppe</label>
          <select class="form-control" id="role" v-model="user.role">
            <option v-for="role in roles" :value="role.id">{{role.name}}</option>
          </select>
        </div>
        -->
        <div class="form-group">
          <button class="btn btn-primary" type="submit">Speichern</button>
        </div>
      </form>
    </main>
  </div>
</template>
<script>
export default {
  data() {
    return {
      password: "",
      passwordRepeat: "",
      user: {
        id: "",
        username: "",
        email: "",
        role: "",
      },
      roles: [
        {
          id: 1,
          name: "Editor"
        },
        {
          id: 2,
          name: "Redaktor"
        },
        {
          id: 3,
          name: "Administrator"
        }
      ]
    };
  },
  methods: {
    save() {
      if (this.password !== this.passwordRepeat)
        return window.alert("The passwords don't match!");

      if(this.password.length < 4)
        return window.alert("The password is too short!")

      let form = new FormData();
      form.append("edit_user[email]", this.user.email);
      form.append("edit_user[username]", this.user.username);
      form.append("edit_user[plainPassword]", this.password);
      form.append("edit_user[givenName]", this.user.givenName);
      form.append("edit_user[familyName]", this.user.familyName);
      form.append("edit_user[isActive]", this.user.isActive);
      form.append("edit_user[roles]", ["ROLE_SUPER_ADMIN"]);

      form.set("edit_user[submit]", null);
      axios
        .post(
          "/api/" +
            store.state.language +
            "/user/" +
            this.$route.params.userId +
            "/edit",
          form
        )
        .then(({ data }) => {
          this.user = data.result;
          alert("Password change successful.");
        });
    }
  },
  created() {
    axios
      .get(
        "/api/" + store.state.language + "/user/" + this.$route.params.userId
      )
      .then(({ data }) => {
        this.user = data.result;
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/user/Form.vue